import React from 'react';
import classNames from 'classnames';
import { FormikTextInput } from 'src/common/form/formik/text-input';
import { MinusRegularIcon } from 'src/monet/icons';
import { NativeFormBaseWithOptions } from '../store';
import { NeueJourneyButton } from '../../components/neue-button/journey';

interface Props extends Pick<NativeFormBaseWithOptions, 'options'> {
  onRemove: (index: number) => void;
  onAdd: () => void;
}

export const NativeFormConfigInputOptions = ({ options, onAdd, onRemove }: Props) => (
  <div className='flex flex-col gap-4'>
    <div className='flex flex-col gap-2'>
      <span className='text-neue-journey-medium-strong'>Options</span>
      {options.map((_, index) => {
        return (
          <div className='flex items-center gap-2'>
            <span className='text-neue-journey-medium text-neue-journey-fg'>{index + 1}.</span>
            <FormikTextInput
              key={`native-form-option-${index}`}
              containerClasses='w-full'
              isNeue
              inputClasses='h-9 w-full'
              className='shrink-0'
              id={`options[${index}].label`}
              name={`options[${index}].label`}
              required
              type='text'
            />
            <div
              className={classNames(
                'flex-shrink-0 text-neue-journey-bg rounded-full bg-neue-journey-fg-10',
                'transition-opacity cursor-pointer h-4 w-4 m-auto'
              )}
              onClick={() => {
                if (options.length === 1) {
                  return;
                }
                onRemove(index);
              }}
            >
              <MinusRegularIcon />
            </div>
          </div>
        );
      })}
    </div>
    <NeueJourneyButton onClick={onAdd} className='h-9'>
      Add option
    </NeueJourneyButton>
  </div>
);
